import axios from 'axios'
import { Message } from 'element-ui'
import qs from 'qs'
import { createSign } from '@/common/signature'
import '../plugins/element'
import router from '@/router'

let API_URL
// console.info('api：', process.env.NODE_ENV)
switch (process.env.NODE_ENV) {
  default:
    API_URL = 'https://server.wenqing123.com/api'
    break
}

const request = axios.create({
  // 配置基本根地址
  baseURL: API_URL,
  // 配置响应头
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  },
})

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    if (
      config.headers['Content-Type'] ===
      'application/x-www-form-urlencoded; charset=UTF-8'
    ) {
      config.transformRequest = [
        function (data) {
          return qs.stringify(data)
        },
      ]
    }
    // 添加当前页面
    config.headers['From-Page'] = location.href
    // 添加token
    config.headers['User-Token'] = localStorage.getItem('user-token') || ''

    if (config.params) {
      // 规整一下请求参数
      config.params = qs.parse(qs.stringify(config.params), {
        arrayLimit: 1000,
      })
    }

    // 加签参数过滤
    let signData = {}
    if (config.data instanceof FormData) {
      let signDataArr = []
      for (let pair of config.data.entries()) {
        if (typeof pair[1] != 'string') {
          continue
        }
        signDataArr.push(pair[0] + '=' + pair[1])
      }
      signData = qs.parse(signDataArr.join('&'))
    } else if (typeof config.data == 'object') {
      signData = config.data
    }
    // 加签参数
    let signParams = Object.assign({}, config.params || {}, signData)
    //时间戳
    let timestamp = String(parseInt(new Date().getTime() / 1000))
    config.headers['X-Timestamp'] = timestamp
    // 签名
    const sign = createSign(signParams, timestamp)
    config.headers['X-Signature'] = sign

    return config
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      // 缓存用户token
      localStorage.setItem('user-token', response.headers['user-token'] || '')
    }
    const code = response.status === 200 ? response.data.code : response.status
    const msg = response.status === 200 ? response.data.msg : 'Network error'
    if (code !== 0) {
      if ([10001, 10002, 10003].indexOf(code) >= 0) {
        localStorage.removeItem('user-token')
        router.push({
          path: '/login',
          query: {
            url: router.app.$route.fullPath,
          },
        })
      } else {
        Message.error(msg)
      }
      return Promise.reject(response)
    }
    return response
  },
  (error) => {
    // Do something with response error
    return Promise.reject(error)
  }
)

export default request
